import type { Joi } from '@ksyos/koi';

interface ForkSchemaOptions {
    makeAllOptional?: boolean;
    makeAllRequired?: boolean;
}

export function cloneAndModifySchema(schema: Joi.Schema, options?: ForkSchemaOptions) {
    const schemaKeys = schema.$_terms.keys.map(({ key }: { key: string }) => key);

    return schema.fork(schemaKeys, (nextSchema) => {
        if (options?.makeAllOptional) {
            return nextSchema.optional();
        }

        if (options?.makeAllRequired) {
            return nextSchema.required();
        }

        return nextSchema;
    });
}
